module.exports = __webpack_public_path__ + "static/media/tds-profile.338d206c.png";